// Components==============
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import destroyProjectGroup from 'actions/project-group/destroy';
import indexProjectGroup from 'actions/project-group/index';
import updateProjectGroup from 'actions/project-group/update';
import indexProject from 'actions/project/index';
import destroyReflection from 'actions/reflection/destroy';
import Avatar from 'components/UI/Avatar/Avatar';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import { useHistory } from 'react-router';
import CircleButton from '../CircleButton/CircleButton';
import './Notification.module.scss';
// =========================

export default function InviteNotification({
  activity,
  reflection,
}: {
  activity?: ProjectGroupEntity;
  reflection?: ReflectionEntity;
}) {
  const dispatch = useReduxAction();
  const translate = useTranslate();

  const id = activity?.id;
  const themeId = activity?.project?.theme_id;
  const user = reflection?.for_user || activity?.invitation;
  const history = useHistory();

  const themeName = useRedux((state) =>
    themeId ? state.theme?.entities.byId[themeId] : undefined
  )?.name;

  if (reflection && !reflection.project_process) return <></>;

  const inviteTitle = activity ? (
    <h3>{`${translate('project.terms.project-invite')}: ${themeName}`}</h3>
  ) : (
    <h3>
      {`${translate('reflection.terms.reflection-invite')}: ${
        reflection?.project_process?.theme?.name
      }`}
    </h3>
  );

  const onReject = () => {
    if (activity)
      dispatch(destroyProjectGroup({ id })).then(() => {
        dispatch(indexProject());
        dispatch(indexProjectGroup());
      });

    if (reflection) dispatch(destroyReflection(reflection.id));
  };

  const onAccept = () => {
    if (activity)
      dispatch(updateProjectGroup({ id, membership: 'member' })).then(() => {
        dispatch(indexProject());
        dispatch(indexProjectGroup());
      });

    if (reflection)
      history.push(
        `/groei/reflecteren/${reflection?.project_process?.project_id}/${reflection?.project_process_id}/${reflection?.id}`
      );
  };

  return (
    <div styleName="notification">
      <div styleName="image">
        <Avatar user={user} size="medium" />
      </div>
      <div styleName="right">
        {inviteTitle}
        <div styleName="description">
          <p>
            <strong>{`${user?.first_name} ${user?.last_name}`}</strong>{' '}
            {translate(
              activity
                ? 'project.collaboration-request-2'
                : 'reflection.reflect-request-2'
            )}
          </p>
          <div styleName="button-wrapper">
            <CircleButton
              icon={faCheck}
              onClick={onAccept}
              color="grey"
              small
            />
            <CircleButton
              icon={faTimes}
              onClick={onReject}
              color="grey"
              small
            />
          </div>
        </div>
      </div>
    </div>
  );
}
